import { useEffect, useState } from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';
import AdminIconButton from './AdminIconButton';

const STORAGE_KEY = 'ken-bryn-admin-theme';
const SYSTEM_THEME_QUERY = '(prefers-color-scheme: dark)';

function getSystemTheme() {
  if (typeof window.matchMedia !== 'function') return 'dark';
  return window.matchMedia(SYSTEM_THEME_QUERY).matches ? 'dark' : 'light';
}

export function useAdminTheme() {
  const [preference, setPreference] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'light' || saved === 'dark') return saved;
    } catch { /* Follow the system when storage is unavailable. */ }
    return 'system';
  });
  const [systemTheme, setSystemTheme] = useState(getSystemTheme);
  const theme = preference === 'system' ? systemTheme : preference;

  useEffect(() => {
    if (preference !== 'system' || typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(SYSTEM_THEME_QUERY);
    const updateTheme = () => setSystemTheme(query.matches ? 'dark' : 'light');
    query.addEventListener('change', updateTheme);
    updateTheme();
    return () => query.removeEventListener('change', updateTheme);
  }, [preference]);

  function toggleTheme() {
    const next = theme === 'dark' ? 'light' : 'dark';
    setPreference(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* Theme still works when storage is unavailable. */ }
  }
  return { theme, toggleTheme };
}

export function AdminThemeToggle({ theme, onToggle }) {
  return <AdminIconButton label="Dark mode" title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} icon={theme === 'dark' ? FiSun : FiMoon} className="admin-theme-toggle" aria-pressed={theme === 'dark'} onClick={onToggle} />;
}
